import React from 'react';
import { IoMdStar } from 'react-icons/io';

const BuyersCard = () => {
  return (
    <div className="bg-white rounded p-4 shadow-cfw mb-16 md:mb-0">
      <div className="flex justify-between">
        <div className="h-10 w-10 overflow-hidden rounded-full my-3">
          <img
            src="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=256&q=80"
            alt="Profile Pic"
            className="inline-block h-full w-full object-cover"
          />
        </div>

        <div className="ml-2">
          <p className="text-sm font-bold">Alexa Farms</p>
          <small className="block text-xs">Volta Region, Town/City</small>
          <div className="mt-3">
            <small className="block text-xs text-cf-300">Need:</small>
            <small className="block text-xs">Soya Beans | 100 tonnes</small>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="text-yellow-600 flex text-lg">
            <IoMdStar />
            <IoMdStar />
            <IoMdStar />
            <IoMdStar />
            <IoMdStar />
          </div>
          <div className="mt-3 flex flex-col">
            <strong className="text-sm mb-1">$ 10,000 - $ 20,000</strong>
            <button className="px-3 py-2 text-white bg-cf-300 rounded shadow-cfw">
              sell to buyer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyersCard;
